import { useNavigate } from "react-router-dom";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  Typography,
} from "@mui/material";

import {
  FREE_PANORAMA_RANGE,
  FREE_PANORAMA_SEARCH_DAYS,
  MAX_PANORAMA_SEARCH_DAYS,
} from "@/constants/membership";
import { useGlobalStoreContext } from "@/context/globalStoreContext";
import usePlatform from "@/hooks/usePlatform";

import { RenderFeatureMobile, RenderFeaturePC, RenderPromotion } from "../ProInfo";

const RegMemberTips = (props: DialogProps) => {
  const store = useGlobalStoreContext();

  const showUpsell = store?.persistStore?.show_upsell;
  // const showUpsell = false;

  const { isPc } = usePlatform();
  const navigate = useNavigate();
  return (
    <Dialog
      {...props}
      PaperProps={{
        sx: {
          borderRadius: "12px",
        },
      }}
    >
      {showUpsell ? (
        <>
          <DialogContent>
            <Typography color="primary" fontSize={18} fontWeight={600}>
              Upgrade to PRO
            </Typography>
            <Typography fontSize={16}>
              You've reached the daily limit of free search. Upgrade to{" "}
              <Typography className="inline" color="primary" fontWeight={"bold"}>
                {" "}
                PRO{" "}
              </Typography>{" "}
              to enjoy unlimited search.
            </Typography>

            <Typography fontSize={16}>
              <Typography className="inline" color="primary" fontWeight={"bold"}>
                {" "}
                PRO{" "}
              </Typography>{" "}
              user enjoys the following benefits that can easily save you thousands of hours:
            </Typography>

            {/* <Typography color="primary" fontSize={16}>
          PRO user enjoys searching through the whole year of data with {MAX_PANORAMA_SEARCH_DAYS}
          -day range.
        </Typography> */}

            <div className="mt-[10px]">{isPc ? <RenderFeaturePC /> : <RenderFeatureMobile />}</div>
            <div>
              <RenderPromotion popup />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              className="center"
              variant="contained"
              onClick={() => {
                window.open("/pro", "_blank", "noopener,noreferrer");
              }}
            >
              Upgrade To PRO
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogContent>
            <Typography color="primary" fontSize={18} fontWeight={600}>
              Daily Search Limit Reached
            </Typography>
            <Typography fontSize={16}>
              You've reached the daily limit of free search. Contact us at team@awardtool.com for
              more information.
            </Typography>
          </DialogContent>
          {/* <DialogActions>
        <Button variant="contained" onClick={() => { navigate("/pro") }} >Upgrade To PRO</Button>
      </DialogActions> */}
        </>
      )}
    </Dialog>
  );
};

export default RegMemberTips;
